<script setup>
defineProps({
  message: {
    type: String,
    default:
      "Envíos chidos a todo México · Rápido, seguro y sin complicaciones",
  },
});

function openWholesale() {
  window.dispatchEvent(
    new CustomEvent("productos-chidos:open-wholesale")
  );
}
</script>

<template>
  <div class="announcement-bar">
    <div class="pc-container announcement-bar__inner">
      <span class="announcement-bar__msg">
        {{ message }}
      </span>

      <button
        type="button"
        class="announcement-bar__cta"
        @click="openWholesale"
      >
        ¿Necesitas muchas piezas?
        <strong>MAYOREO</strong>
      </button>
    </div>
  </div>
</template>
